<template>
  <b-container fluid>
      <b-row v-if="!user.profile.client_side">
          <b-col>
              <app-clients-select-input
                v-model="clientId"
                ></app-clients-select-input>
          </b-col>
      </b-row>
      <b-row v-if="!!theClientId">
          <b-col>
              <app-cameras-review-filters
                :client-id="theClientId"
                @filter="onFilter"
              ></app-cameras-review-filters>
          </b-col>
      </b-row>
      <b-row v-if="!!theClientId && !!camerasReview" class="mt-2">
          <b-col>
              <app-data-table
                :fields="fields"
                :items="camerasReview.data"
                :total="camerasReview.total"
                :from="camerasReview.from"
                :to="camerasReview.to"
                :last-page="camerasReview.last_page"
                :per-page="camerasReview.per_page"
                :current-page="camerasReview.current_page"
                @sort="onSort"
                :on-change-page="onChangePage"
              >
                <template #created_at="{item}">
                    {{item.created_at | datetime}}
                </template>
                <template #actions="data">
                    <b-btn :variant="!!data.item.detailsShowing?'danger':'primary'" size="sm" @click="data.toggleDetails()"><i class="fa fa-eye"></i></b-btn>
                </template>
                <template #row-details="{item}">
                    <div class="details">
                        <b-table fixed :items="item.camera_review_detail" :fields="detailFields"></b-table>
                    </div>
                </template>
              </app-data-table>
          </b-col>
      </b-row>
  </b-container>
</template>

<script>
import appCamerasReviewFilters from "./CamerasReviewFilters.vue";
export default {
    components: {
        appCamerasReviewFilters
    },
    data: () => ({
        camerasReview: null,
        filters: null,
        fields,
        clientId: '',
        clients: [],
        venues: [],
        sortBy: '',
        sortDir: '',
        page: 1,
        detailFields,
    }),
    computed: {
        theClientId() {
            return !!this.client? this.client.id: this.clientId || ''
        }
    },
    watch: {
        theClientId(id) {
            if(!id) return
            this.loadCamerasReview()
        }
    },
    methods: {
        async loadCamerasReview() {
            try {
                const filters = {...this.filters, sortBy: this.sortBy, sortDir: this.sortDir, page: this.page}
                const {data: reviews} = await repo.get(`clients/${this.theClientId}/cameras-review`, filters)
                this.camerasReview = {...reviews, data: reviews.data.map(item => ({...item, _rowDetails: true}))}
            } catch (error) {
                toastr.error('Ocurrió un error cargando la información de las cámaras de vigilancia')
            }
        },
        onFilter(filters) {
            this.page = 1
            this.filters = filters
            this.loadCamerasReview()
        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDir = ctx.sortDir
            this.loadCamerasReview()
        },
        onChangePage(page) {
            this.page = page
            this.loadCamerasReview()
        }
    },
    created() {
        if(!!this.theClientId) {
            this.loadCamerasReview()
        }
    }
}

const fields = [
    {
        key: 'venue.name',
        label: 'Sede',
    },
    {
        key: 'supervisor.name',
        label: 'Reportado por',
    },
    {
        key: 'created_at',
        label: 'Fecha',
    },
    {
        key: 'novelty',
        label: 'Novedad',
    },
    {
        key: 'need_and_recomendation',
        label: 'Recomendaciones',
    },
    {
        key: 'faulty_equipment',
        label: 'Equipos defectuosos',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]

const detailFields = [
    {
        key: 'camera',
        label: 'Cámara',
    },
    {
        key: 'start_time',
        label: 'Hora de inicio',
    },
    {
        key: 'final_hour',
        label: 'Hora de fin',
    },
    {
        key: 'observation',
        label: 'Observaciones',
    },
]
</script>

<style scoped>
.details {
    background-color: beige;
}
</style>
